import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ChartContainerProps {
    children?: React.ReactNode;
}

const ParentChartDiv = styled(Box, {
    name: 'ParentChartDiv'
})((props) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: 'white'
}));

const ChildChartDiv = styled(Box, {
    name: 'ChildChartDiv'
})((props) => ({
    position: 'absolute',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0
}));


export default function ChartContainer(props: ChartContainerProps) {

    return (
        <ParentChartDiv>
            <ChildChartDiv className="chart-child-container">
                {props.children}
            </ChildChartDiv>
        </ParentChartDiv>
    )

}